import { IPaidFeature } from "@evennt-tech/api-v2-core";
import { ProStoragePlan, proStoragePlans } from "ts/api/constraints";

export const isProStoragePlan = (
  feature: IPaidFeature
): feature is ProStoragePlan =>
  (proStoragePlans as string[]).includes(feature.name);

export const calculateRelevantPlanPrice = (
  plan: ProStoragePlan,
  currentPlan?: ProStoragePlan
) => (plan.price ?? 0) - (currentPlan?.price ?? 0);
